import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "state/store";

interface WalletState {
  staleWallet: boolean;
}

const initialState: WalletState = {
  staleWallet: false,
};

// TODO: refactor app to use this slice instead of useWallet. 
// This slice is a hackly way to tell the wallet to update in separate parts of the page
// without passing props from the header all the way into the pool cards. 
const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    setWalletIsStale: (state, action) => {
      state.staleWallet = action.payload;
    },
  },
});

export const { setWalletIsStale } = walletSlice.actions;

export const getWalletState = (state: RootState): WalletState => {
  return state.wallet;
};

export default walletSlice.reducer;